module.exports = __webpack_public_path__ + "img/bookweb.ba2b27c6.png";